import { message } from "antd"

export const SuccessMessage = (msg) => {
    return message.success(msg || 'Success')
}

export const ErrorMessage = (msg, duration) => {
    return message.warning(msg || 'Something went wrong!', duration)
}